import React from 'react';
import Card from './Card';
import PageBanner from '../../layout/PageBanner';
import { Link } from 'react-router-dom';

const Actualidad = (props) => (
  <div>
    <PageBanner title="Actualidad" img="banner-actualidad.jpg">
      <Link to="/">Home</Link>
      <Link to="/actualidad">Actualidad</Link>
    </PageBanner>

    <section className="blog-wrapper blog02">

      <div className="container">
        <div className="row">
          <div className="col-sm-12 section-header03">
            <h2>El programa en los medios</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">

          <div className="col-md-10 col-sm-10 section-header-d" style={{ "width": "100%" }}>
            <div className="blog-six-content">
              <div className="blog-posts">
                <div className="row row row-eq-height">
                  {props.cardsMed.length > 0 &&
                    props.cardsMed.map((card, index) =>
                      <Card
                        image={card.fields.Imagen[0].thumbnails.large.url}
                        video={card.fields.Video}
                        date={card.fields.Fecha}
                        title={card.fields.Titulo}
                        id={card.id}
                        description={card.fields.Descripcion}
                        info={card.fields.Info}
                        key={`card${index}`}
                      />
                    )
                  }
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-sm-12 section-header03">
            <h2>Charlas</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-10 col-sm-10 section-header-d" style={{ "width": "100%" }}>

            <div className="blog-six-content">
              <div className="blog-posts">
                <div className="row row row-eq-height">
                  {props.cardsChar.length > 0 &&
                    props.cardsChar.map((card, index) =>
                      <Card
                        image={card.fields.Imagen[0].thumbnails.large.url}
                        video={card.fields.Video}
                        date={card.fields.Fecha}
                        title={card.fields.Titulo}
                        id={card.id}
                        description={card.fields.Descripcion}
                        info={card.fields.Info}
                        key={`card${index}`}
                      />
                    )
                  }
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 section-header03">
            <h2>Articulos</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-10 col-sm-10 section-header-d" style={{ "width": "100%" }}>

            <div className="blog-six-content">
              <div className="blog-posts">
                <div className="row row row-eq-height">
                  {props.cardsArt.length > 0 &&
                    props.cardsArt.map((card, index) =>
                      <Card
                        image={card.fields.Imagen[0].thumbnails.large.url}
                        video={card.fields.Video}
                        date={card.fields.Fecha}
                        title={card.fields.Titulo}
                        id={card.id}
                        description={card.fields.Descripcion}
                        info={card.fields.Info}
                        key={`card${index}`}
                      />
                    )
                  }
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 section-header03">
            <h2>Convocatorias</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-10 col-sm-10 section-header-d" style={{ "width": "100%" }}>

            <div className="blog-six-content">
              <div className="blog-posts">
                <div className="row row row-eq-height">
                  {props.cardsConv.length > 0 &&
                    props.cardsConv.map((card, index) =>
                      <Card
                        image={card.fields.Imagen[0].thumbnails.large.url}
                        video={card.fields.Video}
                        date={card.fields.Fecha}
                        title={card.fields.Titulo}
                        id={card.id}
                        description={card.fields.Descripcion}
                        info={card.fields.Info}
                        key={`card${index}`}
                      />
                    )
                  }
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      {console.log(props.cardsMisc)}
    </section>

  </div>
);

export default Actualidad;
